import SheetTable from "components/forms/SheetTable";
import React, { useCallback, useMemo } from "react";
// importa o teu SheetTable real
// import SheetTable from "./SheetTable";

const SheetTableCamp = ({
  fieldId,
  formData,
  columns,
  nestedHeaders,
  autoId,
  setFormData, // setter do formData raiz
  scopeKey = null, // ex.: "projectActions"
  selectedObjectId = null, // <-- apenas o ID do objeto selecionado
  rowMove = false,
  maxHeight = 550,
  columnHeaderHeight,
  cells,
}) => {
  const hasSelectedObject =
    selectedObjectId != null && String(selectedObjectId) !== "";
  const isListScoped = Boolean(scopeKey && hasSelectedObject && formData);
  const isMapScoped = Boolean(!scopeKey && hasSelectedObject && formData);

  // 1) Deriva os dados da tabela
  const dataSlice = useMemo(() => {
    if (!formData) return [];
    if (isListScoped) {
      const list = formData[scopeKey] ?? [];
      const item = list.find((x) => String(x?.id) === String(selectedObjectId));
      return item?.[fieldId] ?? [];
    }
    if (isMapScoped) {
      return formData?.[fieldId]?.[selectedObjectId] ?? [];
    }
    return formData[fieldId] ?? [];
  }, [
    fieldId,
    formData,
    isListScoped,
    isMapScoped,
    scopeKey,
    selectedObjectId,
  ]);

  // 2) Setter com assinatura tipo-React (valor ou updater)
  const setData = useCallback(
    (nextOrUpdater) => {
      setFormData((prev) => {
        if (!prev) return prev;

        if (isListScoped) {
          const arr = prev[scopeKey] ?? [];
          const idx = arr.findIndex(
            (x) => String(x?.id) === String(selectedObjectId),
          );
          if (idx === -1) return prev;

          const prevItem = arr[idx];
          const prevSlice = prevItem?.[fieldId] ?? [];

          const nextSlice =
            typeof nextOrUpdater === "function"
              ? nextOrUpdater(prevSlice)
              : nextOrUpdater;

          if (nextSlice === prevSlice) return prev;

          const nextItem = { ...prevItem, [fieldId]: nextSlice };
          const nextArr = [...arr];
          nextArr[idx] = nextItem;

          return { ...prev, [scopeKey]: nextArr };
        }

        if (isMapScoped) {
          const scopedData = prev?.[fieldId] ?? {};
          const prevSlice = scopedData?.[selectedObjectId] ?? [];
          const nextSlice =
            typeof nextOrUpdater === "function"
              ? nextOrUpdater(prevSlice)
              : nextOrUpdater;

          if (nextSlice === prevSlice) return prev;

          return {
            ...prev,
            [fieldId]: {
              ...scopedData,
              [selectedObjectId]: nextSlice,
            },
          };
        }

        // sem scope: atualiza top-level
        const prevSlice = prev?.[fieldId] ?? [];
        const nextSlice =
          typeof nextOrUpdater === "function"
            ? nextOrUpdater(prevSlice)
            : nextOrUpdater;

        if (nextSlice === prevSlice) return prev;
        return { ...prev, [fieldId]: nextSlice };
      });
    },
    [
      fieldId,
      isListScoped,
      isMapScoped,
      scopeKey,
      selectedObjectId,
      setFormData,
    ],
  );

  return (
    <SheetTable
      data={dataSlice}
      columns={columns}
      rowHeaders
      nestedHeaders={nestedHeaders}
      setData={setData}
      autoId={autoId}
      rowMove={rowMove}
      maxHeight={maxHeight}
      columnHeaderHeight={columnHeaderHeight}
      cells={cells}
    />
  );
};

export default SheetTableCamp;
